<template>
  <FriedFloater
    :show="showPopper"
    :main-axis-offset="8"
    :cross-axis-offset="0"
    :placement="Placement.BottomStart"
  >
    <template #reference>
      <FriedIconButton
        :data-external="triggerButtonDataExternal"
        @click="showPopper = true"
        @keydown.escape="closePopper"
      >
        <FriedIcon :size="iconSize" icon="info-circle" />
      </FriedIconButton>
    </template>
    <div v-click-outside="closePopper" class="popper-info-container">
      <FriedH4 v-if="title">{{ title }}</FriedH4>
      <FriedParagraph>
        {{ informationText }}
      </FriedParagraph>
      <FriedButton v-if="url" :data-external="urlButtonDataExternal" @click="openLink">
        <template #leftIcon>
          <FriedIcon icon="share" />
        </template>
        {{ urlButtonText }}
      </FriedButton>
    </div>
  </FriedFloater>
</template>

<script lang="ts">
import { IconSize, Placement } from '@getaccept/fried-tofu';
import type { PropType } from 'vue';
import { defineComponent, ref } from 'vue';
import { UrlHelper } from '@getaccept/lib-shared/src/helpers/url.helper';

export default defineComponent({
  props: {
    informationText: {
      type: String,
      required: true,
    },
    iconSize: {
      type: String as PropType<IconSize>,
      default: IconSize.Medium,
    },
    url: {
      type: String,
      default: null,
      validator: (value: string) => UrlHelper.isValidUrl(value),
    },
    urlButtonText: {
      type: String,
      default: '',
    },
    urlButtonDataExternal: {
      type: String,
      default: 'information-popper-link-button',
    },
    triggerButtonDataExternal: {
      type: String,
      default: 'information-popper-show-button',
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const showPopper = ref(false);

    const closePopper = () => {
      showPopper.value = false;
    };

    const openLink = () => {
      window.open(props.url, '_blank');
    };

    return {
      showPopper,
      closePopper,
      openLink,
      Placement,
    };
  },
});
</script>

<style lang="scss" scoped>
.popper-info-container {
  z-index: $z-tooltip;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-50);
  border-radius: var(--radius-medium);
  padding: var(--spacing-100);
  background: var(--white);
  box-shadow: var(--shadow-3);
  min-width: 18rem;
  max-width: 20rem;

  .button {
    margin-top: var(--spacing-50);
  }
}
</style>
